export const FEATS = [
    // --- Origin Feats ---
    {
        name: "Alert",
        category: "Origin",
        description: "Add Proficiency Bonus to Initiative. Swap Initiative with ally.",
        prerequisites: { level: 1 }
    },
    {
        name: "Crafter",
        category: "Origin",
        description: "Proficiency with 3 Artisan's Tools. 20% discount on nonmagical items. Quick crafting.",
        prerequisites: { level: 1 },
        toolOptions: ["Alchemist's Supplies", "Brewer's Supplies", "Calligrapher's Supplies", "Carpenter's Tools", "Cartographer's Tools", "Cobbler's Tools", "Cook's Utensils", "Glassblower's Tools", "Jeweler's Tools", "Leatherworker's Tools", "Mason's Tools", "Painter's Supplies", "Potter's Tools", "Smith's Tools", "Tinker's Tools", "Weaver's Tools", "Woodcarver's Tools"],
        interactive: 'tool',
        count: 3
    },
    {
        name: "Healer",
        category: "Origin",
        description: "Reroll 1s on healing. Use Healer's Kit to let ally spend Hit Die to heal.",
        actionType: 'Action',
        prerequisites: { level: 1 }
    },
    {
        name: "Lucky",
        category: "Origin",
        description: "Gain Luck Points equal to PB. Spend to gain Advantage or give Disadvantage.",
        prerequisites: { level: 1 }
    },
    {
        name: "Magic Initiate (Cleric)",
        category: "Origin",
        description: "Learn 2 Cleric cantrips and 1 1st-level spell. Cast 1st-level spell once/LR for free.",
        actionType: 'Action',
        prerequisites: { level: 1 }
    },
    {
        name: "Magic Initiate (Druid)",
        category: "Origin",
        description: "Learn 2 Druid cantrips and 1 1st-level spell. Cast 1st-level spell once/LR for free.",
        actionType: 'Action',
        prerequisites: { level: 1 }
    },
    {
        name: "Magic Initiate (Wizard)",
        category: "Origin",
        description: "Learn 2 Wizard cantrips and 1 1st-level spell. Cast 1st-level spell once/LR for free.",
        actionType: 'Action',
        prerequisites: { level: 1 }
    },
    {
        name: "Tough",
        category: "Origin",
        description: "+2 HP per level.",
        prerequisites: { level: 1 }
    },

    {
        name: "Musician",
        category: "Origin",
        description: "Grant Heroic Inspiration to allies after a Short or Long Rest. Gain proficiency with three musical instruments.",
        prerequisites: { level: 1 },
        toolOptions: ['Bagpipes', 'Drum', 'Dulcimer', 'Flute', 'Lute', 'Lyre', 'Horn', 'Pan Flute', 'Shawm', 'Viol'],
        interactive: 'instrument',
        count: 3
    },
    {
        name: "Savage Attacker",
        category: "Origin",
        description: "Reroll damage dice for weapon attacks once per turn.",
        prerequisites: { level: 1 }
    },
    {
        name: "Skilled",
        category: "Origin",
        description: "Gain proficiency in 3 Skills or Tools of your choice.",
        prerequisites: { level: 1 },
        interactive: 'skill',
        count: 3
    },
    {
        name: "Tavern Brawler",
        category: "Origin",
        description: "Unarmed Strike deals 1d4 + STR. Reroll 1s on damage die. Push 5ft on hit once/turn. Proficiency with Improvised Weapons.",
        actionType: 'Action',
        prerequisites: { level: 1 }
    },

    // --- General Feats (Level 4+) ---
    // --- General Feats (Level 4+) ---
    {
        name: "Actor",
        category: "General",
        description: "+1 CHA. Advantage on Deception/Performance to mimic. Mimic sounds.",
        prerequisites: { level: 4, ability: { charisma: 13 } },
        asiOptions: ['charisma']
    },
    {
        name: "Athlete",
        category: "General",
        description: "+1 STR or DEX. Climb speed = Speed. Stand up from prone cost 5ft. Jump with 5ft run.",
        prerequisites: { level: 4, ability: { strength: 13, dexterity: 13 } },
        asiOptions: ['strength', 'dexterity']
    },
    {
        name: "Charger",
        category: "General",
        description: "+1 STR or DEX. Dash increases Speed by 10ft. Charge Attack: +1d8 damage or push 10ft.",
        prerequisites: { level: 4, ability: { strength: 13, dexterity: 13 } },
        asiOptions: ['strength', 'dexterity']
    },
    {
        name: "Chef",
        category: "General",
        description: "+1 CON or WIS. Cook's Utensils prof. Short Rest: extra healing for allies. Long Rest: temp HP treats.",
        prerequisites: { level: 4 },
        asiOptions: ['constitution', 'wisdom']
    },
    {
        name: "Crossbow Expert",
        category: "General",
        description: "+1 DEX. Ignore loading property. No disadvantage in melee. Dual Wielding with Light crossbow.",
        prerequisites: { level: 4, ability: { dexterity: 13 } },
        asiOptions: ['dexterity']
    },
    {
        name: "Crusher",
        category: "General",
        description: "+1 STR or CON. Bludgeoning: Push 5ft once/turn. Crit: Advantage vs target.",
        prerequisites: { level: 4 },
        asiOptions: ['strength', 'constitution']
    },
    {
        name: "Defensive Duelist",
        category: "General",
        description: "+1 DEX. Reaction: Add PB to AC vs melee attack while holding Finesse weapon.",
        prerequisites: { level: 4, ability: { dexterity: 13 } },
        asiOptions: ['dexterity']
    },
    {
        name: "Dual Wielder",
        category: "General",
        description: "+1 STR or DEX. Bonus Action attack with non-Light offhand. Quick Draw two weapons.",
        actionType: 'Bonus Action',
        prerequisites: { level: 4, ability: { strength: 13, dexterity: 13 } },
        asiOptions: ['strength', 'dexterity']
    },
    {
        name: "Durable",
        category: "General",
        description: "+1 CON. Advantage on Death Saves. Bonus Action: Spend Hit Die to heal.",
        prerequisites: { level: 4 },
        asiOptions: ['constitution']
    },
    {
        name: "Elemental Adept",
        category: "General",
        description: "+1 INT/WIS/CHA. Choose damage type: Ignore Resistance, treat 1s as 2s.",
        prerequisites: { level: 4, spellcasting: true },
        asiOptions: ['intelligence', 'wisdom', 'charisma'],
        interactive: 'damageType'
    },
    {
        name: "Fey-Touched",
        category: "General",
        description: "+1 INT/WIS/CHA. Learn Misty Step + 1 Divination/Enchantment spell (free 1/LR).",
        prerequisites: { level: 4 },
        asiOptions: ['intelligence', 'wisdom', 'charisma'],
        interactive: 'spell'
    },
    {
        name: "Grappler",
        category: "General",
        description: "+1 STR or DEX. Attack + Grapple in one unarmed strike. Adv vs Grappled. Fast Wrestler.",
        prerequisites: { level: 4, ability: { strength: 13, dexterity: 13 } },
        asiOptions: ['strength', 'dexterity']
    },
    {
        name: "Great Weapon Master",
        category: "General",
        description: "+1 STR. Heavy Weapon: +PB damage. Crit/Kill: Bonus Action attack.",
        actionType: 'Bonus Action',
        prerequisites: { level: 4, ability: { strength: 13 } },
        asiOptions: ['strength']
    },
    {
        name: "Heavily Armored",
        category: "General",
        description: "+1 CON or STR. Gain Heavy Armor Proficiency.",
        prerequisites: { level: 4, armor: "Medium" },
        asiOptions: ['constitution', 'strength']
    },
    {
        name: "Heavy Armor Master",
        category: "General",
        description: "+1 CON or STR. Reduce non-magical B/P/S damage by PB while in Heavy Armor.",
        prerequisites: { level: 4, armor: "Heavy" },
        asiOptions: ['constitution', 'strength']
    },
    {
        name: "Inspiring Leader",
        category: "General",
        description: "+1 WIS or CHA. Short/Long Rest: 6 allies gain Temp HP (Level + Mod).",
        prerequisites: { level: 4, ability: { wisdom: 13, charisma: 13 } },
        asiOptions: ['wisdom', 'charisma']
    },
    {
        name: "Keen Mind",
        category: "General",
        description: "+1 INT. Skill Proficiency/Expertise (Arcana/History/Investigation/Nature/Religion). Study as Bonus Action.",
        prerequisites: { level: 4, ability: { intelligence: 13 } },
        asiOptions: ['intelligence']
    },
    {
        name: "Lightly Armored",
        category: "General",
        description: "+1 STR or DEX. Gain Light Armor and Shield Proficiency.",
        prerequisites: { level: 4 },
        asiOptions: ['strength', 'dexterity']
    },
    {
        name: "Mage Slayer",
        category: "General",
        description: "+1 STR or DEX. Damage target: Disadvantage on Concentration save. 1/SR Auto-Save vs Mental.",
        prerequisites: { level: 4 },
        asiOptions: ['strength', 'dexterity']
    },
    {
        name: "Martial Weapon Training",
        category: "General",
        description: "+1 STR or DEX. Gain Proficiency with Martial Weapons.",
        prerequisites: { level: 4 },
        asiOptions: ['strength', 'dexterity']
    },
    {
        name: "Medium Armor Master",
        category: "General",
        description: "+1 STR or DEX. Medium Armor: Max DEX AC bonus becomes +3 (from +2).",
        prerequisites: { level: 4, armor: "Medium" },
        asiOptions: ['strength', 'dexterity']
    },
    {
        name: "Moderately Armored",
        category: "General",
        description: "+1 STR or DEX. Gain Medium Armor Proficiency.",
        prerequisites: { level: 4, armor: "Light" },
        asiOptions: ['strength', 'dexterity']
    },
    {
        name: "Mounted Combatant",
        category: "General",
        description: "+1 STR/DEX/WIS. Adv vs unmounted smaller targets. Evasion for mount. Redirect attack to self.",
        prerequisites: { level: 4 },
        asiOptions: ['strength', 'dexterity', 'wisdom']
    },
    {
        name: "Observant",
        category: "General",
        description: "+1 INT or WIS. Skill Proficiency/Expertise (Insight/Investigation/Perception). Search as Bonus Action.",
        prerequisites: { level: 4, ability: { intelligence: 13, wisdom: 13 } },
        asiOptions: ['intelligence', 'wisdom']
    },
    {
        name: "Piercer",
        category: "General",
        description: "+1 STR or DEX. Reroll one piercing damage die. Crit: +1 extra damage die.",
        prerequisites: { level: 4 },
        asiOptions: ['strength', 'dexterity']
    },
    {
        name: "Poisoner",
        category: "General",
        description: "+1 DEX or INT. Ignore Poison Resistance. Poisoner's Kit prof. Craft/Apply poisons.",
        prerequisites: { level: 4 },
        asiOptions: ['dexterity', 'intelligence']
    },
    {
        name: "Polearm Master",
        category: "General",
        description: "+1 STR or DEX. Bonus Action butt strike (d4). Reaction attack when enemy enters reach.",
        actionType: ['Bonus Action', 'Reaction'],
        prerequisites: { level: 4, ability: { strength: 13, dexterity: 13 } },
        asiOptions: ['strength', 'dexterity']
    },
    {
        name: "Resilient",
        category: "General",
        description: "+1 to Chosen Ability. Gain Proficiency in that Saving Throw.",
        prerequisites: { level: 4 },
        asiOptions: ['strength', 'dexterity', 'constitution', 'intelligence', 'wisdom', 'charisma'],
        interactive: 'savingThrow'
    },
    {
        name: "Ritual Caster",
        category: "General",
        description: "+1 INT/WIS/CHA. Learn Ritual spells. Quick Ritual cast 1/LR without extended time.",
        prerequisites: { level: 4, ability: { intelligence: 13, wisdom: 13, charisma: 13 } },
        asiOptions: ['intelligence', 'wisdom', 'charisma']
    },
    {
        name: "Sentinel",
        category: "General",
        description: "+1 STR or DEX. Opportunity attacks reduce speed to 0. React to attack on ally.",
        actionType: 'Reaction',
        prerequisites: { level: 4, ability: { strength: 13, dexterity: 13 } },
        asiOptions: ['strength', 'dexterity']
    },
    {
        name: "Shadow-Touched",
        category: "General",
        description: "+1 INT/WIS/CHA. Learn Invisibility + 1 Illusion/Necromancy spell (free 1/LR).",
        prerequisites: { level: 4 },
        asiOptions: ['intelligence', 'wisdom', 'charisma'],
        interactive: 'spell'
    },
    {
        name: "Sharpshooter",
        category: "General",
        description: "+1 DEX. Ignore cover. Long range no disadvantage. Firing in Melee no disadvantage.",
        prerequisites: { level: 4, ability: { dexterity: 13 } },
        asiOptions: ['dexterity']
    },
    {
        name: "Shield Master",
        category: "General",
        description: "+1 STR. Shield Bash on attack (Prone/Push). Reaction: Interpose Shield for 0 damage on Dex save.",
        actionType: 'Reaction',
        prerequisites: { level: 4, armor: "Shield" },
        asiOptions: ['strength']
    },

    {
        name: "Skill Expert",
        category: "General",
        description: "+1 Any Ability. Gain 1 Skill Prof. Gain 1 Expertise.",
        prerequisites: { level: 4 },
        asiOptions: ['strength', 'dexterity', 'constitution', 'intelligence', 'wisdom', 'charisma'],
        interactive: 'skill'
    },
    {
        name: "Skulker",
        category: "General",
        description: "+1 DEX. Blindsight 10ft. Adv on Hide in combat. Missed hidden attack doesn't reveal.",
        prerequisites: { level: 4, ability: { dexterity: 13 } },
        asiOptions: ['dexterity']
    },
    {
        name: "Slasher",
        category: "General",
        description: "+1 STR or DEX. Slashing hit reduces speed 10ft. Crit: Disadvantage on target.",
        prerequisites: { level: 4 },
        asiOptions: ['strength', 'dexterity']
    },
    {
        name: "Speedy",
        category: "General",
        description: "+1 DEX or CON. +10ft Speed. Dash ignores difficult terrain. Opportunity Attacks vs you have Disadvantage.",
        prerequisites: { level: 4, ability: { dexterity: 13, constitution: 13 } },
        asiOptions: ['dexterity', 'constitution']
    },
    {
        name: "Spell Sniper",
        category: "General",
        description: "+1 INT/WIS/CHA. Spells ignore Cover. Cast in melee no disadvantage. Attack Spell Range +60ft.",
        prerequisites: { level: 4, spellcasting: true },
        asiOptions: ['intelligence', 'wisdom', 'charisma']
    },
    {
        name: "Telekinetic",
        category: "General",
        description: "+1 INT/WIS/CHA. Improved Mage Hand. Bonus Action Shove 5ft (DC check).",
        actionType: 'Bonus Action',
        prerequisites: { level: 4 },
        asiOptions: ['intelligence', 'wisdom', 'charisma']
    },
    {
        name: "Telepathic",
        category: "General",
        description: "+1 INT/WIS/CHA. Telepathy 60ft. Detect Thoughts spell.",
        prerequisites: { level: 4 },
        asiOptions: ['intelligence', 'wisdom', 'charisma']
    },
    {
        name: "War Caster",
        category: "General",
        description: "+1 INT/WIS/CHA. Adv on Con saves for concentration. Cast spell as reaction. Somatic with weapons.",
        actionType: 'Reaction',
        prerequisites: { level: 4, spellcasting: true },
        asiOptions: ['intelligence', 'wisdom', 'charisma']
    },
    {
        name: "Weapon Master",
        category: "General",
        description: "+1 STR or DEX. Use Mastery property of one weapon.",
        prerequisites: { level: 4 },
        asiOptions: ['strength', 'dexterity']
    },

    // --- Fighting Style Feats ---
    {
        name: "Fighting Style: Archery",
        category: "Fighting Style",
        description: "+2 to attack rolls with ranged weapons.",
        prerequisites: { classFeature: "Fighting Style" }
    },
    {
        name: "Fighting Style: Blind Fighting",
        category: "Fighting Style",
        description: "Blindsight 10ft. See invisible/hidden in range.",
        prerequisites: { classFeature: "Fighting Style" }
    },
    {
        name: "Fighting Style: Defense",
        category: "Fighting Style",
        description: "+1 AC while wearing Light, Medium, or Heavy armor.",
        prerequisites: { classFeature: "Fighting Style" }
    },
    {
        name: "Fighting Style: Dueling",
        category: "Fighting Style",
        description: "+2 damage with one-handed melee weapon (no other weapon).",
        prerequisites: { classFeature: "Fighting Style" }
    },
    {
        name: "Fighting Style: Great Weapon Fighting",
        category: "Fighting Style",
        description: "Reroll 1 or 2 on damage dice for Two-Handed/Versatile weapons (used with two hands).",
        prerequisites: { classFeature: "Fighting Style" }
    },
    {
        name: "Fighting Style: Interception",
        category: "Fighting Style",
        description: "Reaction: Reduce damage to ally by 1d10 + PB.",
        actionType: 'Reaction',
        prerequisites: { classFeature: "Fighting Style" }
    },
    {
        name: "Fighting Style: Protection",
        category: "Fighting Style",
        description: "Reaction: Impose Disadvantage on attack vs ally within 5ft (must use Shield).",
        actionType: 'Reaction',
        prerequisites: { classFeature: "Fighting Style" }
    },
    {
        name: "Fighting Style: Thrown Weapon Fighting",
        category: "Fighting Style",
        description: "+2 damage with Thrown weapons. Draw as part of attack.",
        prerequisites: { classFeature: "Fighting Style" }
    },
    {
        name: "Fighting Style: Two-Weapon Fighting",
        category: "Fighting Style",
        description: "Add ability modifier to damage of extra Light weapon attack.",
        prerequisites: { classFeature: "Fighting Style" }
    },
    {
        name: "Fighting Style: Unarmed Fighting",
        category: "Fighting Style",
        description: "Unarmed damage d6+STR (or d8+STR if empty hands). Grapple deals 1d4 damage at start of turn.",
        prerequisites: { classFeature: "Fighting Style" }
    },

    // --- Epic Boons (Level 19+) ---
    {
        name: "Boon of Combat Prowess",
        category: "Epic Boon",
        description: "+1 Ability (max 30). Missed attack hits instead (once/turn).",
        prerequisites: { level: 19 },
        asiOptions: ['strength', 'dexterity', 'constitution', 'intelligence', 'wisdom', 'charisma'],
        interactive: 'asi'
    },
    {
        name: "Boon of Dimensional Travel",
        category: "Epic Boon",
        description: "+1 Ability (max 30). Teleport 30ft after Attack or Magic action.",
        prerequisites: { level: 19 },
        asiOptions: ['strength', 'dexterity', 'constitution', 'intelligence', 'wisdom', 'charisma'],
        interactive: 'asi'
    },
    {
        name: "Boon of Energy Resistance",
        category: "Epic Boon",
        description: "+1 Ability (max 30). Resistance to 2 types. Reaction: Redirect damage to enemy.",
        prerequisites: { level: 19 },
        asiOptions: ['strength', 'dexterity', 'constitution', 'intelligence', 'wisdom', 'charisma'],
        interactive: 'damageType'
    },
    {
        name: "Boon of Fate",
        category: "Epic Boon",
        description: "+1 Ability (max 30). Add/Subtract 2d4 to d20 test (1/SR or LR).",
        prerequisites: { level: 19 },
        asiOptions: ['strength', 'dexterity', 'constitution', 'intelligence', 'wisdom', 'charisma'],
        interactive: 'asi'
    },
    {
        name: "Boon of Fortitude",
        category: "Epic Boon",
        description: "+1 Ability (max 30). +40 Max HP. Heal extra HP equal to CON mod.",
        prerequisites: { level: 19 },
        asiOptions: ['strength', 'dexterity', 'constitution', 'intelligence', 'wisdom', 'charisma'],
        interactive: 'asi'
    },
    {
        name: "Boon of Irresistible Offense",
        category: "Epic Boon",
        description: "+1 STR/DEX (max 30). Bypass Resistance. Crit deals extra damage equal to Ability Score.",
        prerequisites: { level: 19 },
        asiOptions: ['strength', 'dexterity']
    },
    {
        name: "Boon of Recovery",
        category: "Epic Boon",
        description: "+1 Ability (max 30). Drop to 1 HP instead of 0 (1/LR). Heal pool 10d10.",
        prerequisites: { level: 19 },
        asiOptions: ['strength', 'dexterity', 'constitution', 'intelligence', 'wisdom', 'charisma'],
        interactive: 'asi'
    },
    {
        name: "Boon of Skill",
        category: "Epic Boon",
        description: "+1 Ability (max 30). Proficiency in ALL skills. Expertise in one skill.",
        prerequisites: { level: 19 },
        asiOptions: ['strength', 'dexterity', 'constitution', 'intelligence', 'wisdom', 'charisma'],
        interactive: 'asi'
    },
    {
        name: "Boon of Speed",
        category: "Epic Boon",
        description: "+1 Ability (max 30). Speed +30ft. Bonus Action Disengage (ends Grapple).",
        prerequisites: { level: 19 },
        asiOptions: ['strength', 'dexterity', 'constitution', 'intelligence', 'wisdom', 'charisma'],
        interactive: 'asi'
    },
    {
        name: "Boon of Spell Recall",
        category: "Epic Boon",
        description: "+1 INT/WIS/CHA (max 30). 25% chance to not expend spell slot (level 1-4).",
        prerequisites: { level: 19, spellcasting: true },
        asiOptions: ['intelligence', 'wisdom', 'charisma']
    },
    {
        name: "Boon of the Night Spirit",
        category: "Epic Boon",
        description: "+1 Ability (max 30). Dim Light/Darkness: Invisible as Bonus Action + Resistance to all (except Psychic/Radiant).",
        prerequisites: { level: 19 },
        asiOptions: ['strength', 'dexterity', 'constitution', 'intelligence', 'wisdom', 'charisma'],
        interactive: 'asi'
    },
    {
        name: "Boon of Truesight",
        category: "Epic Boon",
        description: "+1 Ability (max 30). Truesight 60ft.",
        prerequisites: { level: 19 },
        asiOptions: ['strength', 'dexterity', 'constitution', 'intelligence', 'wisdom', 'charisma'],
        interactive: 'asi'
    }
];
